<template>
  <ELink
    href="#"
    class="report-link"
    rel="noopener"
    target="_self"
    data-test-id="ad-report"
    @click="$emit('click')"
  >
    {{ $t('common.search.ad.report') }}
  </ELink>
</template>

<script>
import ELink from '~~/common/vue/components/link';

export default {
  name: 'EAdLabelReportLink',
  components: {
    ELink,
  },
};
</script>

<style lang="scss" scoped>
.report-link {
  color: var(--color-link-secondary);
}
</style>
